/*  */

import React, { useEffect, useState }           from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import Grid                                     from '@material-ui/core/Grid'
import { node_server }                          from '../Helpers/index.js'
import Paper                                    from '@material-ui/core/Paper'
import PropTypes                                from 'prop-types'
import Typography                               from '@material-ui/core/Typography'

const GuestBioTitleReadComponent = ( { data, handleClick } ) => {

   const [ displayTitles,                       setDisplayTitles  ]  =  useState([])

   /* This shows the available Historical Entry Titles from the history collection in MongoDB.
      Clicking on a title will then open the <HistoryReadComponent /> for that entry. */
   useEffect(() => {
      axios.get(node_server + 'guestBio/getTitles')
         .then( res => res.data )
         .then( data => {
            setDisplayTitles(data.map( d => {
               return(
               <Grid key={d._id} >
                  <Typography key={d._id} variant='h6' align='left' onClick={() => handleClick(d._id)} style={{ cursor: 'pointer' }} >
                     { d.title }
                  </Typography>
               </Grid>
               )
            }))
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )

   }, [data] )

   return (
      <Box>
         <Paper style={{ marginTop: '50px', margin: '20px', backgroundColor: 'rgba(0, 0, 255, 0.05)' }} >
            <Grid style={{ marginTop: '1rem', marginLeft: '3rem' }} >
               { displayTitles }
            </Grid>
         </Paper>
      </Box>
   )
}

GuestBioTitleReadComponent.propTypes = {
   data:                                        PropTypes.array,
   handleClick:                                 PropTypes.func
}

export default GuestBioTitleReadComponent
